// @ts-nocheck
import { useEffect, useState } from 'react';

import {
  Eye,
  Key,
  Lock,
  ShieldCheck,
  Database,
  ClipboardText,
  Warning,
} from '@phosphor-icons/react';
import { Text, XStack, YStack } from 'tamagui';

import { Header, Footer } from '../components/landing';

const SECTIONS = [
  {
    icon: Eye,
    title: 'Permissions-aware search',
    content:
      'Users only see results they have access to in the original app. If you can\'t see a file in Google Drive, you won\'t find it in Torch. We enforce the same access controls as your connected tools — nothing is surfaced that shouldn\'t be.',
  },
  {
    icon: Key,
    title: 'OAuth scopes',
    content:
      'We request the minimum necessary permissions for each integration. Read-only access where possible. You can review exactly what permissions are granted during each OAuth flow, and revoke access to any connected app at any time from your account settings.',
  },
  {
    icon: Lock,
    title: 'Encryption',
    content:
      'All data is encrypted in transit using TLS 1.3 and at rest using AES-256. OAuth tokens and credentials are stored in encrypted vaults with strict access controls. Infrastructure is hosted on Google Cloud Platform with SOC2-compliant security practices.',
  },
  {
    icon: ShieldCheck,
    title: 'Authentication',
    content:
      'Single sign-on powered by WorkOS. Supports SAML, Google, Microsoft, and email/password authentication. Team and Enterprise plans include enforced SSO policies and admin controls over user access.',
  },
  {
    icon: Database,
    title: 'Data handling',
    content:
      'We index metadata and content from your connected apps to power search. We do not sell, share, or use your data for model training. Your data is yours. When you disconnect an app, associated indexed data is deleted within 30 days. Account deletion removes all data permanently.',
  },
  {
    icon: ClipboardText,
    title: 'Compliance',
    content:
      'SOC2 Type I certification is in progress. We follow security best practices including regular access reviews, infrastructure monitoring, and incident response procedures. For security questionnaires or compliance inquiries, contact us at dans@romans.dev.',
  },
  {
    icon: Warning,
    title: 'Responsible disclosure',
    content:
      'If you discover a security vulnerability, please report it to dans@romans.dev. We take all reports seriously and will respond promptly. We ask that you give us reasonable time to address issues before public disclosure.',
  },
];

export default function SecurityPage() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <YStack backgroundColor="$background" minHeight="100vh">
      <Header />

      <YStack paddingTop={140} paddingHorizontal="$5" gap="$8" paddingBottom={80}>
        <YStack maxWidth={800} alignSelf="center" width="100%">
          {/* Page header */}
          <YStack marginBottom={48}>
            <Text
              fontSize={isMobile ? 30 : 44}
              fontWeight="700"
              letterSpacing={-1.5}
              lineHeight={isMobile ? 36 : 52}
              color="$color12"
            >
              Security
            </Text>
            <Text fontSize={16} color="$color10" lineHeight={26} marginTop="$3">
              How Torch protects your data. Clear answers, no marketing fluff.
            </Text>
          </YStack>

          {/* Sections */}
          <YStack gap="$7">
            {SECTIONS.map((section) => {
              const IconComponent = section.icon;
              return (
                <XStack
                  key={section.title}
                  gap="$5"
                  alignItems="flex-start"
                  flexDirection={isMobile ? 'column' : 'row'}
                >
                  <XStack
                    width={48}
                    height={48}
                    borderRadius="$4"
                    alignItems="center"
                    justifyContent="center"
                    flexShrink={0}
                    style={{ backgroundColor: 'rgba(255, 255, 255, 0.06)' }}
                  >
                    <IconComponent size={24} color="#ededed" />
                  </XStack>
                  <YStack gap="$1" flex={1}>
                    <Text fontSize={20} fontWeight="600" color="$color12" letterSpacing={-0.3}>
                      {section.title}
                    </Text>
                    <Text fontSize={15} color="$color10" lineHeight={26}>
                      {section.content}
                    </Text>
                  </YStack>
                </XStack>
              );
            })}
          </YStack>
        </YStack>
      </YStack>

      <Footer />
    </YStack>
  );
}
